'use strict';exports.__esModule = true;exports.loadCountries = undefined;var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var initialState = {
  loaded: false,
  loading: false,
  data: [],
  error: null };


var loadCountries = (0, _reduxAct.createAction)('/LOAD_COUNTRIES');
var loadCountriesSuccess = (0, _reduxAct.createAction)('/LOAD_COUNTRIES_SUCCESS');
var loadCountriesFail = (0, _reduxAct.createAction)('/LOAD_COUNTRIES_FAIL');

var fetchLoad = function fetchLoad() {return _axios2.default.get('/countries').
  then(loadCountriesSuccess, loadCountriesFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: (0, _get2.default)(action, 'data.data', []).filter(function (it) {return it.name !== 'israel';}) });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while getting cities');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    error: error });

};

var countries = (0, _reduxAct.createReducer)(function (on) {
  on(loadCountries, handleLoad);
  on(loadCountriesSuccess, handleLoadSuccess);
  on(loadCountriesFail, handleLoadFail);
}, initialState);exports.


loadCountries = loadCountries;exports.default =


countries;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/countries.js
// module id = 585
// module chunks = 0